export enum TemplateAccommodationStatusEnum {
  PENDING = 'Pending',
  COMPLETED = 'Completed',
  CANCELLED = 'Canceled',
  ACTIVE = 'Active',
}
